import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import logoSvg from '../../assets/logo.png';

const LogoText = ({ className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <span className="text-nexcess-cyan font-bold">NEXCESS</span>
    <span className="text-nexcess-blue font-bold">INFOTECH</span>
  </div>
);

const Logo = ({ className = "", withText = true, size = "md", animated = false }) => {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-11 h-11",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
    plus: "w-20 h-20"
  };

  const logoComponent = animated ? (
    <motion.img
      src={logoSvg}
      alt="Nexcess Infotech Logo"
      className={`${sizeClasses[size]} object-contain`}
      initial={{ scale: 1 }}
      whileHover={{ scale: 1.1 }}
      transition={{ type: "spring", stiffness: 500, damping: 10 }}
    />
  ) : (
    <img
      src={logoSvg}
      alt="Nexcess Infotech Logo"
      className={`${sizeClasses[size]} object-contain`}
    />
  );

  return (
    <Link to="/" className={`flex items-center space-x-2 ${className}`}>
      {logoComponent}
      {withText && <LogoText className={`text-${size === 'sm' ? 'sm' : size === 'plus' ? '2xl' : size === 'lg' || size === 'xl' ? 'xl' : 'base'}`} />}
    </Link>
  );
};

export default Logo; 